var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg11(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 23,
    viewBox: "0 0 14 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    clipPath: "url(#clip0_417_610)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.4998 13.0944V22.4H8.5748V13.0944H12.3592L13.1467 8.81562H8.5748V7.30187C8.5748 5.04 9.46293 4.17375 11.7554 4.17375C12.4686 4.17375 13.0417 4.19125 13.3742 4.22625V0.345625C12.7486 0.175 11.2173 0 10.3336 0C5.65668 0 3.4998 2.20937 3.4998 6.97375V8.81562H0.612305V13.0944H3.4998Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_417_610"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 22.4,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg11);
export default __webpack_public_path__ + "static/media/1 (1).a5cfce874605c5eb9f78c1accef03346.svg";
export { ForwardRef as ReactComponent };